<script setup lang="ts">
  import { computed, useAttrs } from 'vue';
  import { Loader2 } from 'lucide-vue-next';
  import IconImage from '@/shared/ui/common/IconImage.vue';

  defineOptions({
    inheritAttrs: false,
  });

  const props = withDefaults(
    defineProps<{
      src: string | object;
      alt: string;
      onClick?: () => void;
      disabled?: boolean;
      loading?: boolean;
    }>(),
    { disabled: false, loading: false }
  );

  const attrs = useAttrs();

  // Carregando implica desabilitado: sem isso um segundo clique dispararia a mesma ação de novo.
  const isBlocked = computed(() => props.disabled || props.loading);
</script>

<template>
  <button
    type="button"
    class="group disabled:cursor-not-allowed disabled:opacity-40"
    :aria-label="alt"
    :disabled="isBlocked"
    @click="!isBlocked && onClick && onClick()"
  >
    <Loader2
      v-if="props.loading"
      data-testid="icon-button-loading"
      class="min-h-5 min-w-5 animate-spin text-gray-05"
      v-bind="attrs"
    />
    <IconImage
      v-else
      :src="src"
      :alt="alt"
      class="min-h-5 min-w-5"
      v-bind="attrs"
    />
  </button>
</template>

<style scoped>
  img {
    filter: invert(19%) sepia(10%) saturate(1044%) hue-rotate(207deg) brightness(97%);
  }

  .group:disabled:hover img {
    filter: invert(19%) sepia(10%) saturate(1044%) hue-rotate(207deg) brightness(97%);
  }

  .group:not(:disabled):hover img {
    filter: invert(18%) sepia(95%) saturate(1044%) hue-rotate(-42deg) brightness(80%);
  }
</style>
